import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Container,Row,Col,Button, Card  } from "reactstrap";
import defaultAvatar from "../../../../assets/images/image business défaut.png";
import filter from "../../../../assets/images/cuida_filter-outline.png";
import '../utils/detail.css';
import { getDeveloperById } from "../services/developerApi";
import { getMarchandById } from "../../merchant/services/merchentApi";
import DeveloperInfo from "./DeveloperInfo";
import DeveloperInfoMarchand from "./DeveloperInfoMarchand";
import { ExclamationCircleOutlined, InfoCircleOutlined, WarningOutlined} from "@ant-design/icons";
import ValidateBusiness from "./validateBusiness";
import { Skeleton, Segmented, Tooltip, Tag, Modal, Spin } from "antd";
import { updateDeveloperReversement, updateEnvironment } from "../../../developer/services/developerApi";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import BusinessAction from "./action-business";
import RechargeCompteBusiness from "./recharge-compte-business";
const BusinessManagementDetail = ({onRefresh}) => {
const { id } = useParams();
const [developer, setDeveloper] = useState(null);
const [selectedDeveloper, setSelectedDeveloper] = useState(null);
const [merchantBusiness, setBusinessMerchant] = useState(null);
const [activeTab, setActiveTab] = useState("informations");
const [isManageModalOpen, setIsManageModalOpen] = useState(false);
const [modalMode, setModalMode] = useState("validate");

const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const fetchDeveloper = async () => {
    try {
      const data = await getDeveloperById(id);
      setDeveloper(data);
    } catch (error) {
      console.error("Erreur lors du chargement du business:", error);
    }
  };
const handleEnvironmentChange = async (developer, value) => {
  const mode = value.toUpperCase();

  const updateMode = async () => {
    try {
      await updateEnvironment({
        businessId: developer.id,
        mode: mode
      });

      // ✅ Mettre à jour le state local instantanément
      setDeveloper((prev) => ({
        ...prev,
        environmentMod: mode
      }));

      toast.success(`Mode changé en ${mode}`);

    } catch (error) {
      console.error(error);
      toast.error("Le business doit être actif avant de passer en mode LIVE.");
    }
  };

  if (mode === "LIVE") {
    Modal.confirm({
      title: "Passer en mode LIVE",
      icon: <ExclamationCircleOutlined />,
      content:
        "Vous êtes sur le point de passer ce business en mode LIVE. Les transactions seront réelles.",
      okText: "Passer en LIVE",
      okType: "danger",
      cancelText: "Annuler",
      onOk: updateMode
    });
  } else {
    updateMode();
  }
};

const [isEnabled, setIsEnabled] = useState(developer?.enabled);
useEffect(() => {
  setIsEnabled(developer?.enabled);
}, [developer]);
const updateReversement = async (value) => {
  try {
    await updateDeveloperReversement({
      developerAccountId: developer.id,
      enable: value,
    });
    toast.success(
      value ? "Reversement activé ✅" : "Reversement désactivé ❌"
    );

    if (onRefresh) onRefresh();
  } catch (err) {
    toast.error("Erreur lors de la mise à jour");
  }
};
const handleToggleReversement = async (value) => {
  try {
    await updateDeveloperReversement({
      developerAccountId: developer.id,
      enable: value,
    });

    setIsEnabled(value);

    toast.success(
      value
        ? "Reversement activé ✅"
        : "Reversement désactivé ❌"
    );

    if (onRefresh) onRefresh(); 
  } catch (err) {
    toast.error("Erreur lors de la mise à jour");
  }
};
useEffect(() => {
  
  if (id) {
    fetchDeveloper();
  }
}, [id]);
useEffect(() => {
  const fetchBusinessMerchant = async () => {
    try {
        if (!developer?.merchandId) return;
      const data = await getMarchandById(developer?.merchandId);
      setBusinessMerchant(data);
    } catch (error) {
      console.error("Erreur lors du chargement du business du marchand :", error);
    }
  };
    fetchBusinessMerchant();
  
}, [developer?.merchandId]);
if (!developer) {
  return(
<div
  style={{
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: "10px",
  }}
>
  <Skeleton.Avatar active size="large" shape="circle" />
  <Spin />
</div>
    );
}
  return (
    <>
      <div className="page-content ">
        <Container fluid >
               <Row >
              <Col className="marchand">
                <Link 
                  to={`/marchands/${developer.merchantId}`}
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  <span className="marchands">Business {">"} </span>
                </Link>
                    {developer.businessName} 
              </Col>
            </Row>
             <Card
              style={{
                padding: "12px",
                border: "1px solid #0000001A",
                borderRadius: "12px",  
                backgroundColor: "#FFFFFF"
                }}
            >
            <div className="header-business">
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" ,marginTop:'80px'}}>
                        <img
                          src={developer.logo || defaultAvatar}
                        alt="logo"
                        style={{
                            width: 46,
                            height: 46,
                            borderRadius: "50%",
                            objectFit: "cover"
                        }}
                        />
                    </div>
                     <div
                        style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        textAlign: "center",
                        }}
                        >
                        <span className="name">{developer.businessName}</span>
                  </div>
                    <div className="info-row mb-2">
                      <span className="title">
                        Secteur : {developer.sectorName || "---"}
                      </span>

                      <span className="title">
                        Créé le {developer?.requestDate ? new Date(developer.requestDate).toLocaleString("fr-FR") : "---"}
                      </span>
                    </div>
              <div className="mb-3 actions-row">
                <span
                style={{
                  backgroundColor: developer.isActive ? "#EBFFEA" : "#FFEFD5",
                  color: developer.isActive ? "#349C32" : "#FF7F29",
                  padding: "3px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  borderRadius: "999px",
                }}
              >
                <WarningOutlined/> {developer.isActive ? "Business activé" : "Business désactivé"}
              </span>
                <button
                style={{
                  backgroundColor: developer.isActive ? " #FFF0F0" : "#EBFFEA",
                  color: developer.isActive ? "#D41C1C" : " #349C32",
                  padding: "3px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  borderRadius: "4px",
                  border: "none",
                  outline: "none",
                  cursor: "pointer",
                }}
                onClick={() => {
                setSelectedDeveloper(developer);
                setModalMode(developer.isActive ? "disable" : "validate");
                setIsManageModalOpen(true);
                }}
              >
                {developer.isActive ? "Désactiver le busines" : "Réactiver le business"}
              </button>
            </div> 
  </div>
      <div style={{  justifyContent: "center", alignItems: "start", display: "flex",flexDirection: "column", }}>
          <div className="tabs-container">
        <div
      style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%",
      height: "1px",
      backgroundColor: "#E0E0E0",
        }}
      />
          {["informations","recharge","actions", "Marchand"].map((tab) => (
            <div
              key={tab}
              onClick={() => handleTabClick(tab)}
              style={{
                margin: "0 20px",
                cursor: "pointer",
                color: activeTab === tab ? "#3761FF" : "#00000073",
                fontWeight: activeTab === tab ? 400 : 400,
                fontSize: activeTab === tab ? '16px' : '16px',
                fontFamily: activeTab === tab ? 'Poppins' : 'Poppins',
                fontStyle: activeTab === tab ? 'normal' : 'normal',
                position: "relative",
                paddingBottom: "10px",
              }}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
              {activeTab === tab && (
                <div
                  style={{
                    height: "2px",
                    backgroundColor: "#3761FF",
                    width: "100%",
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                  }}
                />
              )}
            </div>
          ))}
        </div>
        </div>      
        <div className="content-container">
            {activeTab === "informations" && (
              <>
              <DeveloperInfo developer={developer} onRefresh={fetchDeveloper}/>
              </>
              
              )}
               {activeTab === "recharge" && (
              <>
              <RechargeCompteBusiness developer={developer} onRefresh={fetchDeveloper}/>
              </>
              )}
               {activeTab === "actions" && (
              <>
              <BusinessAction 
              developer={developer} 
              onRefresh={fetchDeveloper}
              setDeveloper={setDeveloper}
              setSelectedDeveloper={setSelectedDeveloper}   
              setModalMode={setModalMode}                   
              setIsManageModalOpen={setIsManageModalOpen}   
            />
              </>
              )}
             {activeTab === "Marchand" && (
          <> 
          <DeveloperInfoMarchand developer={developer}/> 
          </>
          )}
        {isManageModalOpen && (
        <ValidateBusiness
          modal={isManageModalOpen}
          setModal={setIsManageModalOpen}
          toggle={() => setIsManageModalOpen(false)}
          selectedDeveloper={selectedDeveloper}
          mode={modalMode}
          onSuccess={fetchDeveloper}
        />
      )}
       </div>
       </Card>
        </Container>
    </div>
    
    </>
   
  );
}
export default BusinessManagementDetail;
